export default __webpack_public_path__ + "static/media/A.4cb642fa.jpg";